import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistReducer,
  // FLUSH,
  // REHYDRATE,
  // PAUSE,
  // PERSIST,
  // PURGE,
  // REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import screenWidthReducer from "./screenWidthSlice";
import freezeAppScrollingReducer from "./freezeAppScrollingSlice";
import userInfoReducer from "./userInfoSlice";
import userLoadingReducer from "./userLoadingSlice";
import userReducer from "./userSlice";

// we are using redux toolkit and slices as described here: https://redux-toolkit.js.org/tutorials/quick-start

const rootReducer = combineReducers({
  // scrolling and screen size of app
  screenWidth: screenWidthReducer,
  freezeAppScrolling: freezeAppScrollingReducer,
  // logged in user info.
  userInfo: userInfoReducer, // user info is small dictionary that contains the firebase auth info, specifically uid, phone email. it is fs auth object.
  userLoading: userLoadingReducer,
  user: userReducer, // this is the actual big firestore document with all the contacts, petition stances, etc. not auth element, the fs db document
});

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: [
    "matchedSelectedVoter",
    "checkVoterInfo",
    "checkVoterInfoSubmitted",
    "checkVoterResults",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
    }),
});
